import React from 'react';
import { toast } from 'react-toastify';
import { IconLink } from '../icons';
import { buildFindLink } from '../links';
import { isEmpty } from './queryOps';
import { copyText } from './util';
import './search.css';

// Copy a ds.php?x=find.1.<token> link for this search (links.js). The
// ds.php?set= show links are App.js's and are not built here.
export const copySearchLink = (bandKey, query) => {
  const link = bandKey ? buildFindLink(bandKey, query) : null;
  if (!link) {
    toast('This search is too long to share as a link.', { type: toast.TYPE.ERROR });
    return Promise.resolve(false);
  }
  return copyText(link).then((ok) => {
    if (ok) toast('Search link copied', { type: toast.TYPE.INFO, autoClose: 2000 });
    else toast('Could not copy the link. Your browser blocked the clipboard.', { type: toast.TYPE.ERROR });
    return ok;
  });
};

// Optional (additive): `label` renders a text button instead of an icon.
export default function ShareSearchButton({ band, query, label }) {
  const bandKey = band && (typeof band === 'string' ? band : band.key);
  const empty = isEmpty(query);
  return (
    <button
      type="button"
      className={label ? 'ss-textbtn' : 'icon-btn'}
      onClick={() => copySearchLink(bandKey, query)}
      disabled={empty || !bandKey}
      title="Copy Search Link"
      aria-label="Copy Search Link"
    >
      <IconLink size={label ? 14 : 17} />
      {label && <span>{label}</span>}
    </button>
  );
}
